<template>
    <ies-form-field :field="field">
        <v-text-field hide-details
            label="E-mail"
            :name="this.field.fieldName"
            v-model="input" v-on:keyup="updateField()"
            :disabled="this.field.disabled"
            :rules="[rules.required, rules.email]"
            outlined
            dense
        ></v-text-field>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value || this.field.oldValue,
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            }
        }
    },
    methods: {
        updateField: function(){
            this.field.value = this.input
        }
    
    }
}
</script>


